import type { ReactNode } from 'react';
import clsx from 'clsx';
import { AppLink } from './AppLink';

interface Props {
  href: string;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg';
  className?: string;
  children: ReactNode;
}

// Always an <a>: every button on this site navigates. The outline variant is
// box-content because the design's 1.5px border sits OUTSIDE its min-height.
export function Button({ href, variant = 'primary', size = 'md', className, children }: Props) {
  return (
    <AppLink
      href={href}
      className={clsx(
        'inline-flex items-center rounded-control font-semibold no-underline',
        size === 'lg' ? 'min-h-[52px] px-[26px] text-[1.0625rem]' : 'min-h-12 px-[22px]',
        variant === 'primary'
          ? 'bg-navy-800 text-white hover:bg-navy-900 hover:text-white'
          : 'box-content border-[1.5px] border-navy-800 text-navy-800',
        className,
      )}
    >
      {children}
    </AppLink>
  );
}
